import { useMemo } from "react";
import { FaqView } from "../components/FaqView";
import { Seo } from "../components/Seo";
import { useLocale } from "../i18n";
import { buildFaqHead } from "../seo";

export function FaqPage() {
  const locale = useLocale();
  const head = useMemo(() => buildFaqHead(locale), [locale]);

  return (
    <>
      <Seo head={head} />
      <FaqView />
    </>
  );
}
